import React from 'react';

import Icon from './Icon';
import styles from './SabaHome.module.css';

export default function DataState({
  loading,
  error,
  retry,
  children,
}: {
  loading: boolean;
  error: boolean;
  retry: () => void;
  children?: React.ReactNode;
}) {
  let message = children || 'هنوز داده‌ای ثبت نشده است';
  if (error) message = 'دریافت اطلاعات ناموفق بود';
  if (loading) message = 'در حال دریافت اطلاعات…';
  return (
    <div className={ styles.dataState } role="status">
      <Icon name={ error ? 'refresh' : 'box' } size={ 30 }/>
      <strong>{ message }</strong>
      { error && (
        <button type="button" onClick={ retry }>
          تلاش دوباره
        </button>
      ) }
    </div>
  );
}
